import axios from "axios"

import { REACT_APP_WORKER_BASE_URL } from "./NewsletterOfferWorkerClient"

const API_ACCESS_KEY = process.env.REACT_APP_API_ACCESS_KEY ?? ""

export const TslNewsletterWorkerClient = axios.create({
  baseURL: REACT_APP_WORKER_BASE_URL,
  headers: {
    "Content-Type": "application/json",
    "X-Access-Key": API_ACCESS_KEY,
  },
})

TslNewsletterWorkerClient.interceptors.request.use(config => {
  const key = process.env.REACT_APP_TSL_NEWSLETTER_ADMIN_API_KEY
  config.headers!["X-Access-Key"] = API_ACCESS_KEY

  if (key && config.headers) {
    config.headers["X-Api-Key"] = key
  }
  return config
})

TslNewsletterWorkerClient.interceptors.response.use(
  response => response.data,
  error => Promise.reject(error),
)
